<tui-root>
    <main class="px-0 md:px-8 xl:px-0 py-16">
    <section *ngIf="currentSurveyStep === 2">
        <div class="storenContainer mx-auto">
            <div *ngIf="firstPage === 1">
                <div class="text-[12px] text-right">* = Required</div>

                <div class="grey-bottom-hr">
                    <h6 class="my-2 text-[26px] font-bold">Your Storen Experience</h6>
                </div>
                <p class="mt-2 text-[14px] text-neutral-500">How are things going so far?</p>

                <div class="tui-form__row mt-4">
                    <p class="text-[16px]">Have you applied Storen corn herbicide to your fields in 2025?<span
                            class="tui-required"></span></p>
                    <div class="border rounded-xl mt-1">
                        <div class="border-bottom" id="applicationCheckin">
                            <label tuiLabel class="m-2 flex justify-between items-center">
                                <div class="flex items-center">
                                    <input tuiRadio type="radio" value="yes"
                                        [formControl]="surveyForm.controls['selectedOption']" class="color-blue" />
                                    <span class="ml-2">Yes</span>
                                </div>
                            </label>
                        </div>
                        <div class="">
                            <label tuiLabel class="m-2 flex justify-between items-center">
                                <div class="flex items-center">
                                    <input tuiRadio type="radio" value="no"
                                        [formControl]="surveyForm.controls['selectedOption']" class="color-blue" />
                                    <span class="ml-2">No</span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedOption === 'yes'" class="yes-section mt-4">
                <form class="bg-white px-0" [formGroup]="surveyForm">
                    <section *ngIf="currentSurveyInnerStep === 1">
                        <div class="tui-form__row tui-form__row_multi-fields">
                            <div class="tui-form__multi-field mt-5">
                                <p class="text-[16px] mb-1">When did you apply Storen corn herbicide to your fields?
                                    <span class="tui-required"></span>
                                </p>
                                <tui-input-date [max]="maxDate" formControlName="applyDate">00/00/00</tui-input-date>
                            </div>
                            <div class="tui-form__multi-field mt-5">
                                <p class="text-[16px] mb-1">How many corn acres did you plant this year? <span
                                        class="tui-required"></span></p>
                                <tui-textfield>
                                    <input tuiInputNumber formControlName="countCornAcres"  [tuiNumberFormat]="{decimalSeparator:'.',thousandSeparator: ','}"/>
                                 </tui-textfield>
                                <tui-error formControlName="countCornAcres" [error]="[] | tuiFieldError | async" />
                            </div>
                        </div>
                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-1">How many corn acres did you treat with Storen corn
                                herbicide?
                                <span class="tui-required"></span>
                            </p>
                            <tui-textfield>
                                <input tuiInputNumber formControlName="storenCornAcresTreated"  [tuiNumberFormat]="{decimalSeparator:'.',thousandSeparator: ','}"/>
                            </tui-textfield>
                            <tui-error formControlName="storenCornAcresTreated"
                                [error]="[] | tuiFieldError | async" />
                        </div>
                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-1">What application rate of Storen did you use? <span
                                    class="tui-required"></span></p>
                            <div class="border rounded-xl mt-1">
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input size="m" tuiRadio type="radio" value="2.1 qt/A"
                                                formControlName="storenAppRate" class="color-blue" (change)="changeApplicationRate($event)"/>
                                            <span class="ml-2">2.1 qt/A</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="border-bottom">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input size="m" tuiRadio type="radio" value="2.4 qt/A"
                                                formControlName="storenAppRate" class="color-blue" (change)="changeApplicationRate($event)"/>
                                            <span class="ml-2">2.4 qt/A</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input size="m" tuiRadio type="radio" value="Other" (change)="changeApplicationRate($event)"
                                                formControlName="storenAppRate" class="color-blue" />
                                            <span class="ml-2">Other</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="tui-form__row" *ngIf="otherRateEnable">
                            <p class="text-[16px] mb-1">If selected “Other” please specify if you used a different
                                rate
                                and why. <span class="tui-required"></span></p>
                            <!-- <tui-input-tag formControlName="storenOtherRate"
                                [tuiTextfieldLabelOutside]="true"></tui-input-tag> -->
                                <tui-input class="mt-1 mb-3" formControlName="storenOtherRate" tuiHintContent="A tooltip"
                                tuiTextfieldSize="m">
                                <input placeholder="Field placeholder" tuiTextfieldLegacy />
                              </tui-input>
                        </div>
                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-1">Did you tank mix any other products with your Storen
                                application?
                                <span class="tui-required"></span>
                            </p>
                            <div class="options-container">
                                <div *ngFor="let option of tankMixProducts; let i = index">
                                    <label tuiLabel class="m-2 flex justify-between">
                                        <div class="flex items-center">
                                            <input size="m" tuiCheckbox type="checkbox" class="color-blue" name="tankMix-{{i}}"
                                                [formControl]="tankMixOptions.at(i)" (change)="changeTankMix($event,option,i)"/>
                                            <span class="ml-2">{{ option }}</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="tui-form__row" *ngIf="tankMixOtherEnable">
                            <p class="text-[16px] mb-1">Other (please specify)<span class="tui-required"></span></p>
                            <!-- <tui-input-tag formControlName="storenOtherApplication" (change)="getTankMixOtherProduct($event)"
                                [tuiTextfieldLabelOutside]="true"></tui-input-tag> -->
                                <tui-input class="mt-1 mb-3" formControlName="storenOtherApplication" tuiHintContent="A tooltip"
                                tuiTextfieldSize="m">
                                <input placeholder="Others" tuiTextfieldLegacy />
                              </tui-input>

                        </div>
                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-1">What are your most challenging weeds? Please select from the
                                list below or add any that are not listed. <span class="tui-required"></span></p>
                            <div class="options-container">

                                <div *ngFor="let option of mostChallengingWeeds; let i = index">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiCheckbox type="checkbox"
                                                [formControl]="mostChallengingWeedsOptions.at(i)" (change)="changeWeeds($event,option,i)"
                                                class="color-blue" />
                                            <span class="ml-2">{{ option }}</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="tui-form__row" *ngIf="weedsOtherEnable">
                            <p class="text-[16px] mb-1">Other (please specify)<span class="tui-required"></span></p>
                            <!-- <tui-input-tag formControlName="storenOtherMostChallenging"
                                [tuiTextfieldLabelOutside]="true"></tui-input-tag> -->
                                <tui-input class="mt-1 mb-3" formControlName="storenOtherMostChallenging" tuiHintContent="A tooltip"
                                tuiTextfieldSize="m">
                                <input placeholder="Others" tuiTextfieldLegacy />
                              </tui-input>
                        </div>
                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-1">Which corn herbicide(s) did you use last season?<span
                                    class="tui-required"></span> Select all that apply.</p>
                            <div class="options-container">
                                <div *ngFor="let option of cornHerbicideList; let i = index">
                                    <label tuiLabel class="m-2 flex justify-between items-center">
                                        <div class="flex items-center">
                                            <input tuiCheckbox type="checkbox"
                                                [formControl]="cornHerbicideListOptions.at(i)" (change)="changeHeribicide($event,option,i)"
                                                class="color-blue" />
                                            <span class="ml-2">{{ option }}</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="tui-form__row" *ngIf="heribicideOtherEnable">
                            <p class="text-[16px] mb-1">Other (please specify)<span class="tui-required"></span></p>
                            <!-- <tui-input-tag formControlName="storenOtherCornHerbicideList"
                                [tuiTextfieldLabelOutside]="true"></tui-input-tag> -->
                                <tui-input class="mt-1 mb-3" formControlName="storenOtherCornHerbicideList" tuiHintContent="A tooltip"
                                tuiTextfieldSize="m">
                                <input placeholder="Others" tuiTextfieldLegacy />
                              </tui-input>
                        </div>

                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] my-2">On a scale from 1 to 5, how would you rate the ease of
                                application
                                of Storen?<span class="tui-required"></span></p>
                            <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="1"
                                            formControlName="selectedStaisfactionScaleOption" class="color-blue" />
                                        <span>1<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Very Difficult</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="2"
                                            formControlName="selectedStaisfactionScaleOption" class="color-blue" />
                                        <span>2<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Somewhat Difficult</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="3"
                                            formControlName="selectedStaisfactionScaleOption" class="color-blue" />
                                        <span>3<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Neutral</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="4"
                                            formControlName="selectedStaisfactionScaleOption" class="color-blue" />
                                        <span>4<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Somewhat Easy</span>
                                    </div>
                                </label>
                                <label tuiLabel class="block md:mx-auto md:w-100 text-center">
                                    <div class="flex radio-flex items-center gap-2">
                                        <input size="m" tuiRadio type="radio" value="5"
                                            formControlName="selectedStaisfactionScaleOption" class="color-blue" />
                                        <span>5<span class="md:hidden inline-block mr-1">.</span></span>
                                        <span>Very Easy</span>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div class="tui-form__row mt-5">
                            <p class="text-[16px] mb-1">Do you have any other comments about your Storen application
                                experience you'd like to share?</p>
                            <tui-textarea formControlName="storenApplicationExperience" class="textAreaSurvey" (change)="charSubstring(surveyForm.value.storenApplicationExperience)"
                                [tuiTextfieldLabelOutside]="true" (keypress)="characValidation(surveyForm.value.storenApplicationExperience)"/>
                                <div class="counter">{{commentsLength || 0}}/1000</div>
                        </div>

                        <div class="tui-form__row mt-5">
                            <button [disabled]="surveyForm.invalid || !isAnyTankSelected() || !isAnyHerbicideSelected() || !isAnyHerbicideSelected()" (click)="submit()" tuiButton appearance="" size="m"
                                class="blue-hover-effect rounded-0 w-full font-bold text-[#FFFFFF] bg-dark-blue">
                                Submit
                            </button>
                        </div>
                    </section>

                    <section class="bg-white mb-5" *ngIf="currentSurveyInnerStep === 2">
                        <div class="row mt-5">
                            <div class="mx-auto">
                                <div class="text-center">
                                    <div class="my-4 flex justify-center items-center">
                                        <img src="../assets/Check.png" alt="" class="w-[92px] h-[92px]">
                                    </div>
                                    <div class="my-4" id="applicationThanks">
                                        <p class="text-[36px] font-bold leading-[37px]">Thank you for your
                                            submission!
                                        </p>
                                        <div class="flex flex-col gap-2 mt-4 text-neutral-500">
                                            <p class="text-[16px] leading-[24px]">You're all set for now, but
                                                there's
                                                more
                                                to come.</p>
                                            <p class="text-[16px] leading-[24px]">In June, we'll email you when it's
                                                time to
                                                submit your Satisfaction Survey and Clean Row photos.</p>
                                            <p class="text-[16px] leading-[24px]">Once you complete that step,
                                                you’ll
                                                have
                                                the opportunity to choose your reward—a SONOSPHEAR<sup>&trade;</sup> speaker or a
                                                Ridge<sup>&reg;</sup>
                                                Wallet.</p>
                                            <p class="text-[16px] leading-[24px]">Thank you for your participation
                                                in
                                                the
                                                Storen Satisfaction Program.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="my-4">
                                    <button (click)="returnDashboard()" tuiButton appearance="primary-grayscale" type="button"
                                        size="m" class="rounded-0 text-white w-100 dark-btn-hover">
                                        Return to Dashboard
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                </form>
            </div>

        </div>



        <div *ngIf="selectedOption === 'no'"
            class="no-section container applicationSelNo max-w-screen-xl h-[150px] mx-auto mt-5 bg-[#b78b1e8c] rounded-xl text-center flex items-center justify-center flex-col">
            <p class="text-[16px]/8 font-bold">Please come back to complete this survey once you've applied Storen<sup>&reg;</sup> corn herbicide to
                your fields.</p>
            <p class="text-[16px]">We're looking forward to hearing about your experience!</p>
        </div>
    </section>
    </main>
</tui-root>